import config from '../config';

export default function getPackage(packageId) {
    return fetch(`${config.cache.apiBaseURL}/packages/${packageId}`, { mode: 'cors' });
}